import { Component, ElementRef, OnInit, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap';
import { AuthService } from '../../_services/auth-service';
import { ValidatorService } from '../../_services/validator-service';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiClientService } from '../../_services/swagger';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { InvitationUploadFiles } from '../../_services/swagger/models';

// objeto para el cortador de imagenes
declare var Cropper: any;

@Component({
  selector: 'app-upload-facial-recognition-invitation',
  templateUrl: 'uploadfacialrecognitioninvitation.component.html',
  styleUrls: ['uploadfacialrecognitioninvitation.component.css']
})
export class UploadFacialRecognitionInvitationComponent implements OnInit, OnDestroy,  AfterViewInit {

  @ViewChild('primaryModal') primaryModal: ModalDirective;
  @ViewChild('idCaptureModal') idCaptureModal: ModalDirective;
  @ViewChild('successModal') successModal: ModalDirective;
  @ViewChild('errorModal') errorModal: ModalDirective;
  @ViewChild('confirmModal') confirmModal: ModalDirective;
  @ViewChild('previewImageFacePhoto') previewImageFacePhoto: ElementRef;
  @ViewChild('previewImageIdentificationPhoto') previewImageIdentificationPhoto: ElementRef;
  @ViewChild('videoElement') videoElement: ElementRef;
  @ViewChild('videoIdElement') videoIdElement: ElementRef;
  @ViewChild('imgCaptured') imgCaptured: ElementRef;

  public frm: FormGroup;

  public successMessage: string;
  public errorMessage: string;
  public loadingMessage = '';
  private token: string;
  private language: string;
  private errorApi: any;
  private invitation: InvitationUploadFiles;
  private loading: boolean;
  private mediaStream: MediaStream;
  private stepCaptured = 1;

  private cropper: any;
  private scriptElement: HTMLScriptElement;
  private linkElement: HTMLLinkElement;
  private showImageHelper = false;
  public idCapturedImageDataURL = '';
  public typeTemplate = 'INE'; // tipo de documento a verificar tomado por el usuario
  public typeTemplates = [
    { value: 'INE', text: 'INE' },
    { value: 'PASSPORT-USA', text: 'Pasaporte Estados Unidos / USA Passport' },
    { value: 'PASSPORT-CANADA', text: 'Pasaporte Canadá / Canada Passport' },
    { value: 'PASSPORT-VENEZUELA', text: 'Pasaporte Venezuela / Venezuela Passport' },
    { value: 'PASSPORT-ITALY', text: 'Pasaporte Italia / Italy Passport' },
    { value: 'PASSPORT-COLOMBIA', text: 'Pasaporte Colombia / Colombia Passport' }
  ];

  private isPolicyAccepted = false;

  // Variables para gestión de cámaras
  private availableCameras: MediaDeviceInfo[] = [];
  private currentCameraIndex = 0;
  private currentModalType: 'face' | 'id' = 'face'; // Para saber qué modal está activo

  get isEn() {
    return this.language === 'en';
  }

  get isIdentificationPhotoRequired(): boolean {
    return this.invitation && this.invitation.identificationPhotoFacialRecognition === 'Obligatorio';
  }

  get alreadySaved(): boolean {
    return this.invitation && this.invitation.facePhoto !== null && this.invitation.facePhoto !== '';
  }

  constructor(private authService: AuthService,
    public frmBuilder: FormBuilder,
    public _validator: ValidatorService,
    private router: Router,
    private _apiClient: ApiClientService,
    private _route: ActivatedRoute,
    private sanitizer: DomSanitizer) {
    this.token = this._route.snapshot.paramMap.get('token');
    this.language = 'es';
  }

  // Devuelve el texto del aviso de privacidad según el idioma seleccionado
  get privacyNotice(): string {
    if (!this.invitation) { return ''; }
    return this.language === 'en'
      ? (this.invitation.privacyNoticeInvitationGuestEN || '')
      : (this.invitation.privacyNoticeInvitationGuestES || '');
  }

  // Devuelve HTML seguro para bindear en la plantilla con [innerHTML]
  get privacyNoticeSafe(): SafeHtml {
    const txt = this.privacyNotice || '';
    return this.sanitizer.bypassSecurityTrustHtml(txt);
  }

  ngOnInit(): void {
    this.getInvitation();
    this.form();
  }

  ngAfterViewInit() {

    // 1. Inyectar CSS
    this.linkElement = document.createElement('link');
    this.linkElement.rel = 'stylesheet';
    this.linkElement.href = 'https://unpkg.com/cropperjs@1.5.12/dist/cropper.css';
    document.head.appendChild(this.linkElement);

    // 2. Inyectar JS
    this.scriptElement = document.createElement('script');
    this.scriptElement.src = 'https://unpkg.com/cropperjs@1.5.12/dist/cropper.js';

    document.body.appendChild(this.scriptElement);

  }

  getInvitation() {
    this._apiClient.getInvitationByToken(this.token).subscribe(
      (data) => {
        this.invitation = data.body.data;
        console.log(this.invitation);
      },
      (error) => {
        // lo mandamos a invitación expirada si es token invalido o expirado
        this.router.navigate(['/expiredinvitation']);
      }
    );
  }

  form() {

    if (this.isIdentificationPhotoRequired) {
      this.frm = this.frmBuilder.group({
        facePhoto: ['', Validators.compose([Validators.required])],
        identificationPhoto: ['', Validators.compose([Validators.required])]
      });
    } else {
      this.frm = this.frmBuilder.group({
        facePhoto: ['', Validators.compose([Validators.required])],
        identificationPhoto: ['']
      });
    }

  }

  openConfirm() {
     // Validar manualmente si los archivos están seleccionados
    if (!this.frm.get('facePhoto').value) {
      this.errorApi = {
        facePhoto: ['El archivo debe ser imagen y es obligatorio']
      };
      return;
    }

    if (this.isIdentificationPhotoRequired && !this.frm.get('identificationPhoto').value) {
      this.errorApi = {
        identificationPhoto: ['El archivo debe ser imagen y es obligatorio']
      };
      return;
    }

    this.confirmModal.show();
  }

  create() {
    this.confirmModal.hide();

    // Validar manualmente si los archivos están seleccionados
    if (!this.frm.get('facePhoto').value) {
      this.errorApi = {
        facePhoto: ['El archivo debe ser imagen y es obligatorio']
      };
      return;
    }

    if (this.isIdentificationPhotoRequired && !this.frm.get('identificationPhoto').value) {
      this.errorApi = {
        identificationPhoto: ['El archivo debe ser imagen y es obligatorio']
      };
      return;
    }

    this.loading = true;
    this.errorMessage = null;

    this._apiClient.uploadFaceAndIDInvitation(this.token, this.frm.value).subscribe(
      (response) => {
        this.loading = false;
        this.successMessage = this.isEn ? 'Files uploaded successfully' : 'Archivos subidos con éxito';
        this.successModal.show();
        this.getInvitation();
        setTimeout(() => {
          this.successModal.hide();
          this.clearFile();
          this.successMessage = null;
        }, 3000);
      },
      (error) => {
        this.loading = false;
        const apiMessage = error && error.error && error.error.message;
        this.errorMessage = apiMessage ? apiMessage : (this.isEn ? 'Error uploading files' : 'Error al subir archivos');
        this.errorModal.show();
        setTimeout(() => {
          this.errorModal.hide();
          this.errorMessage = null;
        }, 3000);
      }
    );
  }

  // Acepta el aviso de privacidad
  acceptPrivacy() {
    this.loading = true;

    this._apiClient.acceptPrivacyPolicyInvitation(this.token).subscribe(data => {
      this.loading = false;
      this.isPolicyAccepted = true;
      this.getInvitation();

    }, () => {
      this.loading = false;
    });
  }

  clearFile() {
    this.frm.get('facePhoto').setValue(null);
    this.frm.get('identificationPhoto').setValue(null);

  }

  ngOnDestroy(): void {
    // Limpiar el stream del video al destruir el componente
    if (this.mediaStream) {
      this.mediaStream.getTracks().forEach(track => {
        track.stop();
      });
      this.mediaStream = null;
    }

    // eliminamos cropper
    if (this.cropper) {
      this.cropper.destroy();
    }
  }

  /* Captura de foto desde la cámara */
  async showCapture() {

    this.primaryModal.show();
    this.stepCaptured = 1;
    this.showImageHelper = false;
    this.currentModalType = 'face';

    // Obtener lista de cámaras disponibles
    await this.getCameras();

    // Seleccionar cámara frontal por defecto
    this.selectDefaultCamera();

    // Iniciar cámara
    this.startCamera();
  }

  // Obtiene lista de cámaras disponibles
  async getCameras() {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      this.availableCameras = devices.filter(device => device.kind === 'videoinput');
      console.log('Cámaras disponibles:', this.availableCameras);
    } catch (error) {
      console.error('Error al obtener lista de cámaras:', error);
    }
  }

  // Selecciona la cámara por defecto según el tipo de modal
  selectDefaultCamera() {
    if (this.availableCameras.length === 0) {
      return;
    }

    let selectedIndex = 0;

    if (this.currentModalType === 'face') {
      // Para rostro: buscar cámara frontal (selfie)
      const frontIndex = this.availableCameras.findIndex(cam => {
        const label = cam.label.toLowerCase();
        return label.includes('front') ||
               label.includes('frontal') ||
               label.includes('user') ||
               label.includes('face') ||
               label.includes('selfie');
      });
      selectedIndex = frontIndex >= 0 ? frontIndex : 0;
    } else {
      // Para ID: buscar cámara trasera (para credenciales)
      const backIndex = this.availableCameras.findIndex(cam => {
        const label = cam.label.toLowerCase();
        return label.includes('back') ||
               label.includes('rear') ||
               label.includes('environment') ||
               label.includes('trasera');
      });
      selectedIndex = backIndex >= 0 ? backIndex : 0;
    }

    this.currentCameraIndex = selectedIndex;
    console.log('Cámara seleccionada por defecto (' + this.currentModalType + '):', this.availableCameras[this.currentCameraIndex].label);
  }

  // Inicia la cámara según el índice seleccionado
  startCamera(useExact: boolean = false) {
    // Detener stream anterior si existe
    if (this.mediaStream) {
      this.mediaStream.getTracks().forEach(track => track.stop());
      this.mediaStream = null;
    }

    let constraints: MediaStreamConstraints;

    if (this.availableCameras.length > 0 && this.availableCameras[this.currentCameraIndex]) {
      // Usar exact cuando se cambia manualmente, ideal cuando se inicia
      const deviceIdConstraint = useExact
        ? { exact: this.availableCameras[this.currentCameraIndex].deviceId }
        : { ideal: this.availableCameras[this.currentCameraIndex].deviceId };

      constraints = {
        video: { deviceId: deviceIdConstraint },
        audio: false
      };
    } else {
      // Fallback con facingMode
      constraints = {
        video: { facingMode: this.currentModalType === 'face' ? 'user' : 'environment' },
        audio: false
      };
    }

    navigator.mediaDevices.getUserMedia(constraints)
      .then((stream) => {
        this.showImageHelper = this.currentModalType === 'face';
        this.mediaStream = stream;

        if (this.currentModalType === 'face') {
          this.videoElement.nativeElement.srcObject = stream;
        } else {
          this.videoIdElement.nativeElement.srcObject = stream;
        }
      })
      .catch((error) => {
        console.error('Error accessing media devices.', error);
        // Si falla con deviceId, intentar con facingMode
        if (constraints.video && typeof constraints.video === 'object' && 'deviceId' in constraints.video) {
          this.startCameraFallback();
        } else {
          // Si ya estaba usando facingMode, mostrar error
          this.errorMessage = this.isEn
            ? 'Cannot access camera. Please check permissions.'
            : 'No se puede acceder a la cámara. Verifica los permisos.';
        }
      });
  }

  // Fallback para iniciar cámara con facingMode si falla con deviceId
  startCameraFallback() {
    const constraints: MediaStreamConstraints = {
      video: { facingMode: this.currentModalType === 'face' ? 'user' : 'environment' },
      audio: false
    };

    navigator.mediaDevices.getUserMedia(constraints)
      .then((stream) => {
        this.showImageHelper = this.currentModalType === 'face';
        this.mediaStream = stream;

        if (this.currentModalType === 'face') {
          this.videoElement.nativeElement.srcObject = stream;
        } else {
          this.videoIdElement.nativeElement.srcObject = stream;
        }
      })
      .catch((error) => {
        console.error('Error en fallback de cámara:', error);
        this.errorMessage = this.isEn
          ? 'Cannot access camera. Please check permissions.'
          : 'No se puede acceder a la cámara. Verifica los permisos.';
      });
  }

  // Cambia a la siguiente cámara disponible
  switchCamera() {
    if (this.availableCameras.length <= 1) {
      console.log('No hay múltiples cámaras disponibles');
      return;
    }

    // se hace un cambio de camara circular
    this.currentCameraIndex = (this.currentCameraIndex + 1) % this.availableCameras.length;
    console.log('Cambiando a cámara:', this.availableCameras[this.currentCameraIndex].label);
    this.startCamera(true); // Usar exact=true para forzar el cambio
  }

  // Verifica si hay múltiples cámaras disponibles
  get hasMultipleCameras(): boolean {
    return this.availableCameras.length > 1;
  }


  closeCapture() {
    // Detener todas las pistas del stream de video
    if (this.mediaStream) {
      this.mediaStream.getTracks().forEach(track => {
        track.stop();
      });
      this.mediaStream = null;
    }

    // Limpiar el srcObject del elemento de video
    if (this.videoElement && this.videoElement.nativeElement) {
      this.videoElement.nativeElement.srcObject = null;
    }

    // Resetear índice de cámara
    this.currentCameraIndex = 0;

    this.primaryModal.hide();
  }

  capturePhoto() {
    this.stepCaptured = 2;

    const video = this.videoElement.nativeElement;
    const canvas = this.imgCaptured.nativeElement;
    const context = canvas.getContext('2d');

    // Establecer las dimensiones del canvas igual al video
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    // Dibujar el frame actual del video directamente en el canvas del HTML
    context.drawImage(video, 0, 0, canvas.width, canvas.height);

    this.initCropper();
  }

  initCropper() {
    const canvas = this.imgCaptured.nativeElement;

    if (this.cropper) {
      this.cropper.destroy();
    }

      this.cropper = new Cropper(canvas, {
        aspectRatio: 270 / 378, // relación de 270 / 378 = 5 / 7
        viewMode: 1,
        responsive: true,
        dragMode: 'move',      // 🔥 Mueve la imagen en lugar del cuadro de recorte
        cropBoxMovable: false, // 🔥 El cuadro no se puede mover
        cropBoxResizable: false, // 🔥 El cuadro no se puede redimensionar
        guides: false,         // Opcional: quita las guías
        center: true,          // Mantiene centrado el recuadro
        background: true,       // Fondo sombreado

        // 🔥 control de redimensionado/zoom
        zoomable: true,          // permitir zoom (scroll del mouse o pinch en móvil)
        scalable: true,          // permitir escalar con gestos (pinch)
        movable: true,            // permitir mover la imagen
         ready() {
            // 🔹 Establece el tamaño exacto del recorte
            this.cropper.setCropBoxData({
              width: 270,
              height: 378
            });
         }
      });
  }

  async cutPhoto() {
      if (!this.cropper) { return; }

      const croppedCanvas = this.cropper.getCroppedCanvas({
        width: 270,
        height: 378,
      });

      const croppedImageDataURL = croppedCanvas.toDataURL('image/jpeg');

      const face = croppedImageDataURL.split(',')[1];

      const isValidFace = await this.validateFace(face);

      if (!isValidFace) {
        this.errorMessage = this.isEn ? 'The captured face is not valid. Please try again.' : 'El rostro capturado no es válido. Por favor, inténtelo de nuevo.';
        this.errorModal.show();
        setTimeout(() => {
          this.errorModal.hide();
          this.errorMessage = null;
        }, 2000);
        this.closeCapture();
        this.showCapture();
        return;
      }

      // Asignar la imagen recortada al formulario y vista previa
     // this.previewImageFacePhoto.nativeElement.src = croppedImageDataURL;
      this.previewImageFacePhoto.nativeElement.src = croppedImageDataURL; // usamos el elemento de vista previa que se selecciono, así funciona con distintos en caso de editar y nueva foto
     // this.frm.get('facePhoto').setValue(croppedImageDataURL.split(',')[1]);
      this.frm.get('facePhoto').setValue(face); // usamos el formulario que se selecciono, así funciona con distintos en caso de editar y nueva foto

      // Cerrar el modal de captura
      this.closeCapture();
  }


  // captura de id --------------------------
  async showIdCapture() {

    this.idCaptureModal.show();
    this.currentModalType = 'id';
    this.idCapturedImageDataURL = '';

    // Obtener lista de cámaras disponibles
    await this.getCameras();

    // Seleccionar cámara frontal por defecto
    this.selectDefaultCamera();

    // Iniciar cámara
    this.startCamera();
  }

  closeIdCapture() {
    // Detener todas las pistas del stream de video
    if (this.mediaStream) {
      this.mediaStream.getTracks().forEach(track => {
        track.stop();
      });
      this.mediaStream = null;
    }

    // Limpiar el srcObject del elemento de video
    if (this.videoIdElement && this.videoIdElement.nativeElement) {
      this.videoIdElement.nativeElement.srcObject = null;
    }

    this.idCapturedImageDataURL = '';

    // Resetear índice de cámara
    this.currentCameraIndex = 0;

    this.idCaptureModal.hide();
  }

  captureIdPhoto() {

    // pasa lor que tiene videoIdElement a un img
    const video = this.videoIdElement.nativeElement;
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    if (!context) { return; }

    // Establecer las dimensiones del canvas igual al video
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    // Dibujar el frame actual del video directamente en el canvas del HTML
    context.drawImage(video, 0, 0, canvas.width, canvas.height);

    this.idCapturedImageDataURL = canvas.toDataURL('image/jpeg');

    if (this.mediaStream) {
      this.mediaStream.getTracks().forEach(track => track.stop());
      this.mediaStream = null;
    }

    if (this.videoIdElement && this.videoIdElement.nativeElement) {
      this.videoIdElement.nativeElement.srcObject = null;
    }
  }

  // descarta la captura sin validar y reactiva la cámara
  retakeIdPhoto() {
    this.idCapturedImageDataURL = '';
    this.startCamera();
  }

  // valida la identificación capturada y, si es válida, la asigna al formulario
  async confirmIdPhoto() {
    if (!this.idCapturedImageDataURL || !this.typeTemplate || this.loading) { return; }

    const capturedImageDataURL = this.idCapturedImageDataURL;
    const identificationPhoto = capturedImageDataURL.split(',')[1];

    const isValidIdentification = await this.validateIdentification(identificationPhoto);

    if (!isValidIdentification) {
      this.errorMessage = this.isEn ? 'The captured identification is not valid. Please try again.' : 'La identificación capturada no es válida. Por favor, inténtelo de nuevo.';
      this.errorModal.show();
      setTimeout(() => {
        this.errorModal.hide();
        this.errorMessage = '';
      }, 2000);
      this.idCapturedImageDataURL = '';
      this.startCamera();
      return;
    }

    this.previewImageIdentificationPhoto.nativeElement.src = capturedImageDataURL; // usamos el elemento de vista previa que se selecciono
    const identificationPhotoControl = this.frm.get('identificationPhoto');
    if (identificationPhotoControl) {
      identificationPhotoControl.setValue(identificationPhoto); // usamos el formulario que se selecciono
    }

    // Cerrar el modal de captura
    this.idCapturedImageDataURL = '';
    this.idCaptureModal.hide();
  }


  // verifica si es un rostro válido
  async validateFace(facePhoto: string) {
    this.loading = true;

    try {
      const resp = await this._apiClient.checkValidFaceInvitation(this.token, { facePhoto }).toPromise();
      this.loading = false;
      console.log(resp.body.data);
      return resp.body.data; // regresa true o false si el rostro es o no es valido
    } catch (error) {
      this.loading = false;
      return false;
    }
  }

  // verifica si es una identificación válida
  async validateIdentification(identificationPhoto: string) {
    this.loading = true;
    this.loadingMessage = this.isEn ? 'We are validating your document' : 'Estamos validando tu documento';

    try {
      const resp = await this._apiClient.checkValidIdentificationInvitation(this.token, { identificationPhoto, typeTemplate: this.typeTemplate }).toPromise();
      this.loading = false;
      this.loadingMessage = '';
      const data = resp.body && resp.body.data;
      return data && typeof data === 'object' ? data.isValid === true : data === true;
    } catch (error) {
      this.loading = false;
      this.loadingMessage = '';
      return false;
    }
  }
}
